import { AxiosError } from 'axios'
import type { ChildEditionId, ErrorResponseData } from '@/types'

export const isForbidden = (error: unknown) =>
  error instanceof AxiosError && error?.response?.status === 403

export const isNotFound = (error: unknown) =>
  error instanceof AxiosError && error?.response?.status === 404

export const isAxiosError = (error: unknown): error is AxiosError<ErrorResponseData> =>
  error instanceof AxiosError

export const throwIfInvalidChildEditionId = (childEditionId: ChildEditionId | undefined) => {
  if (!Number.isInteger(Number(childEditionId))) {
    throw Object.assign(new Error('invalid child edition id'), {
      response: { status: 404 }
    })
  }
}
